import mapboxgl from "mapbox-gl";
import { parseContourFile } from "./ImportContourUtils"; 
import { renderToStaticMarkup } from "react-dom/server";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import { createElement } from "react";
import i18n from "../../i18n/i18n";

const IMPORT_ICON_SVG = renderToStaticMarkup(
  createElement(FileUploadIcon, { style: { width: 19, height: 19 } })
);
export const updateImportContourButtonTooltip = () => {
  const button = document.querySelector(".mapbox-gl-draw_import");
  if (!button) return;
  button.title = i18n.t("mapControls.importContour");
  button.setAttribute("data-tooltip", i18n.t("mapControls.importContour"));
};
export const addImportContourButton = ({
  mapRef,
  drawRef,
  onImportError,
  onImportSuccess,
}) => {
  const drawGroup = Array.from(
    document.querySelectorAll(".mapboxgl-ctrl-group"),
  ).find((group) => group.querySelector(".mapbox-gl-draw_polygon"));

  if (!drawGroup) return null;
  if (drawGroup.querySelector(".mapbox-gl-draw_import")) return null;

  const button = document.createElement("button");
  button.className = "mapbox-gl-draw_ctrl-draw-btn mapbox-gl-draw_import";
  button.title = i18n.t("mapControls.importContour");
  button.type = "button";
  button.setAttribute("data-testid", "draw-import-button");
  button.setAttribute("data-tooltip", i18n.t("mapControls.importContour"));
  button.style.display = "flex";
  button.style.alignItems = "center";
  button.style.justifyContent = "center";
  button.innerHTML = IMPORT_ICON_SVG;

  const fileInput = document.createElement("input");
  fileInput.type = "file";
  fileInput.accept = ".geojson,.json,.kml";
  fileInput.style.display = "none";
  fileInput.setAttribute("data-testid", "draw-import-input");

  button.addEventListener("click", (e) => {
    e.preventDefault();
    fileInput.value = "";
    fileInput.click();
  });

  fileInput.addEventListener("change", async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    try {
      // 👇 plural now: { features, wasReprojected, detectedEpsg }
      const { features, wasReprojected, detectedEpsg } =
        await parseContourFile(file);

      if (!drawRef.current) return;
      if (!features || features.length === 0) return;

      const addedIds = drawRef.current.add({
        type: "FeatureCollection",
        features,
      });

      // Fly/fit the map to all imported polygon(s)
      if (mapRef.current) {
        const bounds = new mapboxgl.LngLatBounds();
        features.forEach((feature) => {
          const coords = feature.geometry.coordinates[0];
          coords.forEach((c) => bounds.extend(c));
        });
        mapRef.current.fitBounds(bounds, { padding: 50 });
      }

      onImportSuccess?.({
        features,
        wasReprojected,
        detectedEpsg,
        addedIds,
      });
    } catch (err) {
      console.error("Import contour error:", err);
      onImportError?.(err.message || i18n.t("mapControls.importError"));
    }
  });

  drawGroup.appendChild(button);
  drawGroup.appendChild(fileInput);

  return { button, fileInput };
};